import { render, staticRenderFns } from "./BaseScreenshot.vue?vue&type=template&id=203d5eca&scoped=true"
import script from "./BaseScreenshot.vue?vue&type=script&lang=js"
export * from "./BaseScreenshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d5eca",
  null
  
)

export default component.exports